// extracted by mini-css-extract-plugin
module.exports = {"recommend":"_1476","title":"_2976","list":"_17408"};